import React from 'react';
import './App.css';
import { ReactComponent as RelaisLogo } from './logo.svg'; 
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import Signup from './components/auth/Signup';
import Login from './components/auth/Login';
import { AuthProvider } from './contexts/AuthContext';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { DesignProvider } from './contexts/DesignContext';
import { AssistantProvider } from './contexts/AssistantContext';
import ProtectedRoute from './routes/ProtectedRoute';
import MainDashboard from './components/dashboard/MainDashboard';
import DesignCanvas from './components/dashboard/DesignCanvas'; //  Keep this
import UserProfile from './components/auth/UserProfile';
import PremiumPage from './pages/PremiumPage';
import SubmitPaymentProofPage from './pages/SubmitPaymentProofPage';
import AccountHistoryPage from './components/dashboard/AccountHistoryPage';

function App() {
    return (

	
        <Router>
            <AuthProvider>
                <DesignProvider>
                    <AssistantProvider>
                        <DndProvider backend={HTML5Backend}>
                            <Routes>
                                <Route path="/" element={<HomePage />} />
                                <Route path="/signup" element={<Signup />} />
                                <Route path="/login" element={<Login />} />
                                {/* Protected Routes */}
                                <Route element={<ProtectedRoute />}>
                                    <Route path="/dashboard" element={<MainDashboard />} />
                                    <Route path="/design/:designId" element={<DesignCanvas />} />  {/* Keep this */}
									<Route path="/design/:designId/components" element={<DesignCanvas />} />
									<Route path="/design/:designId/components/:componentId" element={<DesignCanvas />} />
									<Route path="/design/:designId/connections" element={<DesignCanvas />} />
									<Route path="/design/:designId/connections/:connectionId" element={<DesignCanvas />} />
                                    <Route path="/profile" element={<UserProfile />} />
									<Route path="/premium" element={<PremiumPage />} />
									<Route path="/submit-payment-proof" element={<SubmitPaymentProofPage />} />
									<Route path="/account-history" element={<AccountHistoryPage />} />
                                </Route>
                            </Routes>
                        </DndProvider>
                    </AssistantProvider>
                </DesignProvider>
            </AuthProvider>
        </Router>
    );
}

export default App;